import Vue from "vue";
import { moduleFactory } from "@/store/resource";
import { unionBy } from "lodash";
import { http } from "@/communication";

const resourceModule = moduleFactory("profileVisit");

resourceModule.mutations.oldUpdate = resourceModule.mutations.update;
resourceModule.mutations.update = (state, resources) => {
  const updateResources = Array.isArray(resources) ? resources : [resources];
  const unionResources = unionBy(
    state[`profileVisits`],
    updateResources,
    resource => resource.id
  );
  Vue.set(state, `profileVisits`, unionResources);
};

resourceModule.mutations.buy = (state, resources) => {
  let modelIndex = state[`profileVisits`].findIndex(
    model => model.id === resources.id
  );
  Vue.set(state[`profileVisits`], modelIndex, resources);
};

resourceModule.actions.buy = ({ commit }, data) => {
  return http
    .post("/api/v1/profileVisit/" + data + "/buy")
    .then(response => {
      commit("buy", response.data);
      return response;
    })
    .catch(error => {
      console.log(`${name}s error`, error);
    });
};

export const profileVisitModule = resourceModule;
